import { Box, Button, Divider, Inline, Stack, Text } from "@seneca/senekit";

import IconGoogle from "common/assets/images/sso/google.svg";
import IconMicrosoft from "common/assets/images/sso/microsoft.svg";

import { getProviderDisplayName } from "services/firebase/auth/ssoProvider";

const iconProviderMap = {
  Google: IconGoogle,
  Microsoft: IconMicrosoft
};

type Props = {
  provider: {
    providerId: string;
    email?: string;
  };
  handleConnectionChange: (
    providerId: string,
    isConnectionLinked: boolean,
    email?: string
  ) => void;
  loading: boolean;
  disabled: boolean;
  idx: number;
};

export default function SSOProviderRow({
  provider: { providerId, email },
  handleConnectionChange,
  loading,
  disabled,
  idx
}: Props) {
  const isConnectionLinked = !!email;
  const providerName = getProviderDisplayName(providerId);
  return (
    <Box marginTop="small">
      <Stack>
        {idx !== 0 && (
          <Box marginBottom="xlarge">
            <Divider direction="horizontal" />
          </Box>
        )}

        <Inline alignItems="center" justifyContent="space-between">
          <Inline alignItems="center" space="xlarge">
            <Box marginTop="large">
              <img
                src={(iconProviderMap as any)[providerName]}
                alt={providerName}
              />
            </Box>

            <Stack>
              <Box>
                <Text
                  dataNoTranslate
                  tone="neutral"
                  weight="bold"
                  size="medium"
                >
                  {providerName}
                </Text>
              </Box>

              <Box display={["none", "block"]}>
                <Text dataNoTranslate tone="neutral" size="small">
                  {email}
                </Text>
              </Box>
            </Stack>
          </Inline>

          <Button
            onClick={() => {
              handleConnectionChange(providerId, isConnectionLinked);
            }}
            loading={loading}
            disabled={disabled}
            width={"120px"}
            fill={isConnectionLinked ? "filledTonal" : "outlined"}
            accessibilityLabel={`${
              isConnectionLinked ? "Disconnect from" : "Connect with"
            } ${providerName}`}
          >
            {isConnectionLinked ? "Disconnect" : "Connect"}
          </Button>
        </Inline>
      </Stack>
    </Box>
  );
}
